<app-mychart-web-header 
    [firstName]="patientFirstName">
</app-mychart-web-header>
<div *ngIf="isMobileResolution==false" class="search-background-web">
    <div class="search-container-web">
        <div class="search-title-web">
            {{title}}
        </div>
        <div *ngIf="(searchMode$ | async)==='provider'" class="search-sub-container-web">
            <div class="search-toggle-container-web">
                <button mat-button class="search-toggle-btn-selected-web" (click)="toggleSearchMode('provider')" >{{providerBtnText}}</button>
                <button mat-button class="search-toggle-btn-unselected-web" (click)="toggleSearchMode('location')">{{locationBtnText}}</button>
            </div>
        </div>
        <div *ngIf="(searchMode$ | async)==='location'" class="search-sub-container-web">
            <div class="search-toggle-container-web">
                <button mat-button class="search-toggle-btn-unselected-web" (click)="toggleSearchMode('provider')" >{{providerBtnText}}</button>
                <button mat-button class="search-toggle-btn-selected-web" (click)="toggleSearchMode('location')">{{locationBtnText}}</button>
            </div>
        </div>
        <div class="search-sub-container-web">
            <div class="search-query-container-web">
                <div *ngIf="(searchMode$ | async)==='provider'">
                    <app-provider-search
                        *ngIf="(providerSearchResults$ | async) === null"  
                        [locale]="locale" 
                        [currentLocation]="currentLocation"
                        [providerQuickSearchOptions]="providerQuickSearchOptions"
                        [providerSearchFilters]="providerSearchFilters"
                        [providerSearchTypeAheadOptions]="providerSearchTypeAheadOptions"
                        [cityTypeAheadOptions]="cityTypeAheadOptions"
                        [patientAffiliation]="patientAffiliation">
                    </app-provider-search>
                    <div *ngIf="(providerSearchResults$ | async) !== null" style="display: flex; gap: 30px; overflow-x: auto;">
                        <div *ngIf="(providerSearchFilterToggle$ | async) == true && (searchMode$  | async) === 'provider'" style="flex: 0 0 auto;">
                            <app-provider-search-filter 
                                [currentLocation]="currentLocation"
                                [patientAffiliation]="patientAffiliation"
                                [providerSearchTypeAheadOptions]="providerSearchTypeAheadOptions">
                            </app-provider-search-filter>
                        </div>
                        <div *ngIf="(providerDetails$ | async) === null" style="flex: 1 1 auto;">
                            <app-provider-search-results
                                [locale]="locale"
                                [currentLocation]="currentLocation"
                                [cityTypeAheadOptions]="cityTypeAheadOptions">
                            </app-provider-search-results>
                        </div>
                        <div *ngIf="(providerDetails$ | async) !== null && (providerDetailsLocation$ | async) === null" style="flex: 1 1 auto; overflow-x: auto;">
                            <app-provider-search-details
                                [currentLocation]="currentLocation"
                                [locale]="locale">
                            </app-provider-search-details>
                        </div>
                        <div *ngIf="(providerDetailsLocation$ | async) !== null" style="flex: 1 1 auto; overflow-x: auto;">
                            <app-location-search-details
                                [currentLocation]="currentLocation"
                                [locale]="locale"
                                [fromProviderSearch]="fromProviderSearch"
                                [providerDetails]="providerDetails"
                                [currentCityOrZip]="currentCityOrZip">
                            </app-location-search-details>
                        </div>
                    </div>
                </div>
                <div *ngIf="(searchMode$ | async)==='location'">
                    <app-location-search
                        *ngIf="(locationSearchResults$ | async) === null"
                        [locale]="locale" 
                        [currentLocation]="currentLocation"
                        [locationQuickSearchOptions]="locationQuickSearchOptions"
                        [locationSearchFilters]="locationSearchFilters"
                        [cityTypeAheadOptions]="cityTypeAheadOptions"
                        [locationSearchTypeAheadOptions]="locationSearchTypeAheadOptions">
                    </app-location-search>
                    <div *ngIf="(locationSearchResults$ | async) !== null" style="display: flex; gap: 30px; overflow-x: auto;">
                        <div *ngIf="(locationSearchFilterToggle$ | async) == true && (searchMode$  | async) === 'location'" style="flex: 0 0 auto;">
                            <app-location-search-filter 
                                [currentLocation]="currentLocation">
                            </app-location-search-filter>
                        </div>
                        <div *ngIf="(locationDetails$ | async) === null" style="flex: 1 1 auto;">
                            <app-location-search-results
                                [locale]="locale"
                                [currentLocation]="currentLocation"
                                [cityTypeAheadOptions]="cityTypeAheadOptions">
                            </app-location-search-results>
                        </div>
                        <div *ngIf="(locationDetails$ | async) !== null && (locationDetailsProvider$ | async) === null" style="flex: 1 1 auto; overflow-x: auto;">
                            <app-location-search-details
                                [currentLocation]="currentLocation"
                                [locale]="locale"
                                [currentCityOrZip]="currentCityOrZip">
                            </app-location-search-details>
                        </div>
                        <div *ngIf="(locationDetailsProvider$ | async) !== null" style="flex: 1 1 auto; overflow-x: auto;">
                            <app-provider-search-details
                                [currentLocation]="currentLocation"
                                [locale]="locale"
                                [fromLocationSearch]="fromLocationSearch"
                                [locationDetails]="locationDetails"
                                [currentCityOrZip]="currentCityOrZip">
                            </app-provider-search-details>
                        </div>
                    </div>
                </div>
            </div>
            <div class="custom-container-web"><br><br></div>
        </div>
    </div>
</div>
<div *ngIf="isMobileResolution===true">
    <div class="search-container-mobile">
        <!-- Search Mode Toggle -->
        <div *ngIf="(providerSearchResults$ | async) === null && (locationSearchResults$ | async) === null" class="search-toggle-container-mobile">
            <button 
                mat-button 
                [class.search-toggle-btn-selected]="(searchMode$ | async) === 'provider'"
                [class.search-toggle-btn-unselected]="(searchMode$ | async) !== 'provider'"
                (click)="toggleSearchMode('provider')">
                {{providerBtnText}}
            </button>
            <button 
                mat-button 
                [class.search-toggle-btn-selected]="(searchMode$ | async) === 'location'"
                [class.search-toggle-btn-unselected]="(searchMode$ | async) !== 'location'"
                (click)="toggleSearchMode('location')">
                {{locationBtnText}}
            </button>
        </div>

        <!-- Search Content Area -->
        <div class="search-content-mobile">
            <!-- Provider Search Mode -->
            <div *ngIf="(searchMode$ | async) === 'provider'">
                <!-- Show search input if no results -->
                <app-provider-search-mobile
                    *ngIf="(providerSearchResults$ | async) === null"  
                    [locale]="locale"
                    [isPlus]="isPlus || false"
                    [currentLocation]="currentLocation"
                    [providerQuickSearchOptions]="providerQuickSearchOptions"
                    [providerSearchFilters]="providerSearchFilters"
                    [patientAffiliation]="patientAffiliation"
                    [providerTypeAheadOptions]="providerSearchTypeAheadOptions"
                    [cityZipTypeAheadOptions]="cityTypeAheadOptions">
                </app-provider-search-mobile>
                
                <!-- Show results if search has been performed -->
                <div *ngIf="(providerSearchResults$ | async) !== null">
                    <!-- Show filter panel overlay if toggle is true -->
                    <app-provider-search-filter-mobile
                        *ngIf="(showSpinner$ | async) === false && (providerSearchFilterToggle$ | async) === true && (providerSearchFilters$ | async) !== null"
                        [isPlus]="isPlus || false"
                        [providerTypeAheadOptions]="providerSearchTypeAheadOptions">
                    </app-provider-search-filter-mobile>                <!-- Show results -->
                    <app-provider-search-results-mobile
                        *ngIf="(providerDetails$ | async) === null"
                        [isPlus]="isPlus || false"
                        [currentLocation]="currentLocation"
                        [cityZipTypeAheadOptions]="cityTypeAheadOptions">
                    </app-provider-search-results-mobile>
                    <app-provider-search-details-mobile
                        *ngIf="(providerDetails$ | async) !== null && (providerDetailsLocation$ | async) === null"
                        [isPlus]="isPlus || false"
                        [currentLocation]="currentLocation">
                    </app-provider-search-details-mobile>
                    <app-location-search-details-mobile
                        *ngIf="(providerDetails$ | async) !== null && (providerDetailsLocation$ | async) !== null"
                        [providerDetails]="providerDetails"
                        [providerDetailsLocation]="providerDetailsLocation">
                    </app-location-search-details-mobile>
                </div>
            </div>

            <!-- Location Search Mode -->
            <div *ngIf="(searchMode$ | async) === 'location'">
                <!-- Show search input if no results -->
                <app-location-search-mobile
                    *ngIf="(locationSearchResults$ | async) === null"  
                    [locale]="locale"
                    [isPlus]="isPlus || false"
                    [currentLocation]="currentLocation"
                    [locationQuickSearchOptions]="locationQuickSearchOptions"
                    [locationSearchFilters]="locationSearchFilters"
                    [locationTypeAheadOptions]="locationSearchTypeAheadOptions"
                    [cityZipTypeAheadOptions]="cityTypeAheadOptions">
                </app-location-search-mobile>
                
                <!-- Show results if search has been performed and no location detail is selected -->
                <div *ngIf="(locationSearchQuery$ | async) !== null && (locationDetails$ | async) === null">
                    <!-- Show filter panel overlay if toggle is true -->
                    <app-location-search-filter-mobile
                        *ngIf="(showSpinner$ | async) === false && (locationSearchFilterToggle$ | async) === true  && (locationSearchFilters$ | async) !== null"
                        [isPlus]="isPlus || false"
                        [currentLocation]="currentLocation">
                    </app-location-search-filter-mobile>
                    
                    <!-- Show results -->
                    <app-location-search-results-mobile
                        [isPlus]="isPlus || false"
                        [currentLocation]="currentLocation"
                        [cityZipTypeAheadOptions]="cityTypeAheadOptions">
                    </app-location-search-results-mobile>
                </div>

                <!-- Show location details when a location is selected -->
                <app-location-search-details-mobile
                    *ngIf="(locationDetails$ | async) !== null && (locationDetailsProvider$ | async) === null"
                    [isPlus]="isPlus || false">
                </app-location-search-details-mobile>
                <app-provider-search-details-mobile
                        *ngIf="(locationDetails$ | async) !== null && (locationDetailsProvider$ | async) !== null"
                        [locationDetails]="locationDetails"
                        [locationDetailsProvider]="locationDetailsProvider">
                </app-provider-search-details-mobile>
            </div>
        </div>
    </div>
</div>
